import { render } from "./YoutubePlayer.vue?vue&type=template&id=139daf1c"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js"

import "./YoutubePlayer.vue?vue&type=style&index=0&id=139daf1c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__